export default {
  title: 'Il tuo provider gestisce questo passaggio',
  description: {
    payments: 'Contatta {{partner}} per attivare i pagamenti online.',
    go_live: 'Contatta {{partner}} per attivare il tuo ristorante.',
  },
  fallback_partner: 'il tuo provider',
};
